<template>
  <Navbar></Navbar>
  <div class="product-detail-page">
    <div class="detail-banner">
      <div class="img-box detail-banner-img"><img src="/assets/product/engine/4N20A/4N20A.jpg" alt=""></div>
      <div class="detail-banner-r">
        
        <div class="detail-banner-t2">4N20A 2.0米勒循环发动机</div>
        <div class="detail-banner-desc">
          4N20A纵置系列基于4N20技术升级，保持高热效指标的同时，提升动力性，搭载公司纵置越野整车平台，高能、高效、高可靠，适应91#/92#/95#/E100弹性燃料等国内及国际多种油品。
        </div>
      </div>
    </div>

    <div class="detail-box">
      <div class="detail-title">核心参数</div>
      <div class="detail-utils">
        <div class="detail-utils-item">
          <div class="detail-utils-d">最大功率</div>
          <div class="detail-utils-u">180kW/6000rpm</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">最大扭矩</div>
          <div class="detail-utils-u">380N·m/1700~4000rpm</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">燃油消耗率最低</div>
          <div class="detail-utils-u">220g/kW·h</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">热效率</div>
          <div class="detail-utils-u">38%</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">排放水平</div>
          <div class="detail-utils-u">国6b</div>
        </div>
      </div>
    </div>

    <div class="detail-box">
      <div class="detail-title">核心技术</div>
      <div class="detail-desc"></div>
      <div class="detail-four-list">
        <div class="detail-four-item">
          <div class="img-box"><img src="/assets/product/engine/4N20A/4N20A-1.jpg" alt=""></div>
        </div>
        <div class="detail-four-item">
          <div class="detail-four-title">高效燃烧系统</div>
          <div class="detail-four-desc">
            米勒循环、高压缩比、缸内直喷、350bar喷射压力、90mJ高能点火。
          </div>
        </div>
        <div class="detail-four-item">
          <div class="detail-four-title">智能热管理系统</div>
          <div class="detail-four-desc">
            机械水泵+热管理，满足越野车型的高散热需求；<br />动态控制流量、水温，系统响应快，降低油耗率。
          </div>
        </div>
        <div class="detail-four-item">
          <div class="img-box"><img src="/assets/product/engine/4N20A/4N20A-2.jpg" alt=""></div>
        </div>
      </div>

    </div>
    <div class="detail-swiper-list detail-box">
      <div class="img-box detail-swiper-right ">
        <img src="/assets/product/engine/4N20A/4N20A-3.jpg" alt=""></img>
      </div>
      <div class="detail-swiper-left">
        <div>
          <div class="detail-title">
            P0轻混架构
          </div>
          <div class="detail-desc">
            匹配48V-BSG电机，实现辅助发电、提升发动机启停平顺性及支持驱动附件降低怠速转速，改善燃油经济性。
          </div>
        </div>
      </div>
    </div>

  </div>
  <Footer></Footer>
</template>

<script setup>
import { ref, nextTick, onMounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
const swiperInstances = ref({});

onMounted(() => {
  nextTick(() => {
    const swiperContainers = document.querySelectorAll('.swiper-container');

    swiperContainers.forEach((container, index) => {
      const containerKey = `swiper_${index}`;
      container.dataset.swiperKey = containerKey;
      const swiperInstance = new Swiper(container, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 300,
        preventClicks: true,
        effect: 'fade',
      });
      swiperInstances.value[containerKey] = swiperInstance;
    });

    bindTabClickEvent();
  });
});
function bindTabClickEvent() {
  const allSwiperLists = document.querySelectorAll('.detail-swiper-list');

  allSwiperLists.forEach((swiperList) => {
    const tabItems = swiperList.querySelectorAll('.detail-tab-item');
    const targetSwiperContainer = swiperList.querySelector('.swiper-container');

    if (!tabItems.length || !targetSwiperContainer) return;

    const containerKey = targetSwiperContainer.dataset.swiperKey;
    const targetSwiper = swiperInstances.value[containerKey];
    if (!targetSwiper) return;

    const handleTabAction = (tabItem, localTabIndex) => {
      tabItems.forEach(item => item.classList.remove('active'));
      tabItem.classList.add('active');
      targetSwiper.slideTo(localTabIndex, 300, true);
    };
    tabItems.forEach((tabItem, localTabIndex) => {
      const handleTabClickWrapper = () => {
        handleTabAction(tabItem, localTabIndex);
      };
      tabItem.removeEventListener('click', handleTabClickWrapper);
      tabItem.removeEventListener('mouseenter', handleTabClickWrapper);
      tabItem.addEventListener('click', handleTabClickWrapper);
      tabItem.addEventListener('mouseenter', handleTabClickWrapper);
    });
  });
}

</script>

<script>
export const pageConfig = {
  title: '4N20A 2.0米勒循环发动机 - 蜂巢汽车官网',
  keywords: '蜂巢,蜂巢汽车,发动机,变速箱,电子',
  description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
  outputPath: 'engine/4N20A.html'
};

import { createApp } from 'vue';
import App from './4N20A.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"
import "@/assets/styles/product-details.scss"

function mountApp() {
  const appNode = document.getElementById('app');
  if (appNode) {
    if (appNode._vueApp) {
      appNode._vueApp.unmount();
      delete appNode._vueApp;
    }
    const app = createApp(App);
    app.use(store);
    appNode._vueApp = app.mount(appNode);
  }
}

// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
  module.hot.accept('./4N20A.vue', () => {
    mountApp();
  });
}
</script>

<style lang="scss" scoped></style>